// Vaste lijst van de twaalf oorspronkelijke plaatspagina's (menu, footer, formulieren).
// De inhoud per plaats staat in de database en is te beheren via Beheer → Werkgebied.
export const CITIES = [
  { slug: "maassluis", name: "Maassluis" },
  { slug: "vlaardingen", name: "Vlaardingen" },
  { slug: "schiedam", name: "Schiedam" },
  { slug: "rotterdam", name: "Rotterdam" },
  { slug: "den-haag", name: "Den Haag" },
  { slug: "delft", name: "Delft" },
  { slug: "westland", name: "Westland" },
  { slug: "spijkenisse", name: "Spijkenisse" },
  { slug: "rijswijk", name: "Rijswijk" },
  { slug: "zoetermeer", name: "Zoetermeer" },
  { slug: "capelle-aan-den-ijssel", name: "Capelle aan den IJssel" },
  { slug: "berkel-en-rodenrijs", name: "Berkel en Rodenrijs" },
];

export const getCity = (slug) => CITIES.find((c) => c.slug === slug);
